import { getLocalizedProductText } from '../components/chat/utils/productHelpers'

const useChatSubmission = ({
  input,
  typing,
  productsLoading,
  productFlowStep,
  selectedProduct,
  questionStep,
  questions,
  getAnswersMap,
  findNextVisibleQuestion,
  askQuestion,
  advanceQuestion,
  addAiMessage,
  addUserMessage,
  clearInput,
  upsertDerivedAnswer,
  dispatch,
  setProductFlowStep,
  translations = {},
  language = 'EN',
}) => {
  const startConversation = () => {
    const firstStep = findNextVisibleQuestion(0, getAnswersMap())

    if (firstStep !== null) {
      askQuestion(firstStep)
    }
  }

  const send = () => {
    const text = input.trim()

    if (!text || typing) return

    addUserMessage({
      text,
    })

    clearInput()

    if (productFlowStep === 'decline_reason') {
      upsertDerivedAnswer('productDeclineFeedback', {
        productName: selectedProduct?.name || null,
        reason: text,
      })

      addAiMessage({
        text: getLocalizedProductText({
          translations,
          language,
          keyPath: 'productFlow.thanksForSharing',
          fallback:
            'Thanks for sharing. Would you like to continue exploring or log out?',
        }),
      })

      dispatch(setProductFlowStep('next_action'))
      return
    }

    if (questionStep === -1) {
      startConversation()
      return
    }

    if (questionStep >= 0 && questionStep < questions.length) {
      advanceQuestion(text)
    }
  }

  const handleButtonAnswer = (value, label = value) => {
    if (typing || productsLoading) return

    addUserMessage({
      text: label,
    })

    if (questionStep === -1) {
      startConversation()
      return
    }

    if (questionStep >= 0 && questionStep < questions.length) {
      advanceQuestion(value)
    }
  }

  return {
    startConversation,
    send,
    handleButtonAnswer,
  }
}

export default useChatSubmission
